import { TableCell, TableRow, Tooltip } from "@mui/material";
import { EditOutlined, VisibilityOutlined } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import TableDesign from "../../../../../components/common/table/TableDesign";
import { tableSurveyHeadings } from "./utils";

interface InvSurveyItemProps {
  items?: any[];
  onEdit?: (item: any, index: number) => void;
  disableEdit?: boolean;
}

const InvSurveyItem = ({
  items = [],
  onEdit,
  disableEdit = false,
}: InvSurveyItemProps) => {
  const headings = onEdit
    ? [...tableSurveyHeadings, { label: "Actions", align: "center" as const }]
    : tableSurveyHeadings;

  return (
    <>
      <TableDesign
        tableHeadings={headings}
        tableHeadColor={"#02906f"}
        cellColor={"#fff"}
        //   pagination={InvData?.length > 0 ? 1 : null}
        isLoader={false}
        stickyHeader={true}
        filterOption={() => {}}
        setFilterOption={() => {}}
        extraCSS={{
          height: "calc(100%)",
        }}
      >
        {items.length > 0 ? (
          items.map((val: any, idx: number) => (
            <TableRow
              key={val?.id || idx}
              sx={{
                cursor: "pointer",
                marginTop: "10px",
                padding: "4px !important",
                borderRadius: "20px !important",
                height: "20px !important",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                  outline: "2px solid #f0f0f0",
                  borderRadius: "0px !important",
                  outlineOffset: "-2px !important",
                },
              }}
            >
              <TableCell align="center">{val?.ref_id ?? idx + 1}</TableCell>
              <TableCell>{val?.title ?? val?.item ?? val?.item_name ?? "—"}</TableCell>
              <TableCell>{val?.quantity ?? val?.qty ?? "—"}</TableCell>
              <TableCell>{val?.condition_code ?? val?.condition ?? "—"}</TableCell>
              {/* <TableCell align="center">{val?.crate_ref ?? val?.crate ?? "—"}</TableCell> */}
              <TableCell align="center">
                {val?.photo_url ? (
                  <Tooltip title="View photo">
                    <IconButton
                      component="a"
                      size="small"
                      href={val.photo_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View photo of ${val?.title ?? val?.item ?? "inventory item"}`}
                    >
                      <VisibilityOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                ) : val?.photo_key ? (
                  "Uploaded"
                ) : (
                  "—"
                )}
              </TableCell>
              {onEdit && (
                <TableCell align="center">
                  <IconButton
                    size="small"
                    aria-label={`Edit ${val?.title ?? val?.item ?? "inventory item"}`}
                    disabled={disableEdit}
                    onClick={() => onEdit(val, idx)}
                  >
                    <EditOutlined fontSize="small" />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={headings.length} align="center">
              {`No Data Found!`}
            </TableCell>
          </TableRow>
        )}
      </TableDesign>
    </>
  );
};

export default InvSurveyItem;
